import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AppLayout = ({ routes, children }) => {
    const location = useLocation();

    useEffect(() => {
        const currentRoute = routes.find(route => route.path === location.pathname);
        if (currentRoute) {
            document.title = currentRoute.title || 'Default Title';
        }
    }, [location, routes]);

    return (
        <div>
            {children}
        </div>
    );
};

AppLayout.propTypes = {
    routes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            title: PropTypes.string
        })
    ).isRequired,
    children: PropTypes.node.isRequired
};

export default AppLayout;